import { invalidParamsMessage, typeOfHopintoInvalidParamsDialog } from '@Pages/Hopinto/constants';
import store from '@Store';
import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';

export const goToLanding = () => {
  history.push(paths.SEARCH);
};

export const goToAdvancedSearch = (params) =>
  history.push({
    pathname: paths.ADVANCED,
    state: { ...params },
  });

export const showInvalidParamsDialog = () => {
  store.dispatch(
    updateDialog({
      id: typeOfHopintoInvalidParamsDialog,
      dialogType: typeOfHopintoInvalidParamsDialog,
      movable: false,
      backdrop: true,
      closeBtn: false,
      message: invalidParamsMessage,
    })
  );
};
